import { AbstractComponentModalController } from '../../helpers/angular';

/**
 * @class InfoModalController
 * @template M
 */
export class InfoModalController extends AbstractComponentModalController {
    
    static get bindings() {
        return {
            resolve: '<',
            close: '&',
            dismiss: '&'
        };
    }
    
    cancel() {
        this.dismiss({$value: 'cancel'});
    }
}

export const InfoModalComponent = {
    selector:   'infoModal',
    template:   require('./info-modal.component.html'),
    controller: InfoModalController,
    bindings:   InfoModalController.bindings
};



// WEBPACK FOOTER //
// ./src/app-modules/info-modal/info-modal.component.js